import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import PostiesLogo from "~/components/posties/header/common/img-logo-posties.svg";

import ScmpLogo from "./scmp-logo.svg";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100vw;
  block-size: 100vh;
  max-inline-size: 400px;
  margin: auto;

  border-radius: 8px;

  background-color: #f6f6f6;

  outline: none;

  ${props => props.theme.breakpoints.up("mobile")} {
    max-block-size: 667px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;

  inline-size: 60px;
  block-size: 60px;
  padding: 20px;

  background-color: transparent;

  cursor: pointer;
`;

export const StyledScmpLogo = styled(ScmpLogo)`
  inline-size: 47px;
  block-size: 36px;
  margin-block-start: 20px;

  ${props => props.theme.breakpoints.up("mobile")} {
    margin-block-start: 52px;
  }
`;

export const StyledPostiesLogo = styled(PostiesLogo)`
  inline-size: 220px;
  margin-block-start: 20px;

  ${props => props.theme.breakpoints.up("mobile")} {
    margin-block-start: 52px;
  }
`;

export const LoginForm = styled.div`
  padding-block: 0;
  padding-inline: 64px;

  & #sa-login-widget-title {
    margin-block: 24px;
  }
`;

export const Disclaimer = styled.div`
  inline-size: 270px;
  max-inline-size: 320px;
  margin-block-start: auto;
  padding-block: 24px;
  padding-inline: 0;

  color: #999999;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
  text-align: center;

  & a {
    display: inline;

    color: #999999;
    font-size: 12px;
    font-family: ${fontRoboto};
    text-decoration: underline;
  }
`;
